import { Button, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import NoAccessIcon from "../icons/NoAccessIcon";
import InfoPage from "./infoPage/InfoPage";

interface Props {
  userEmail?: string;
  onSignInWithAnotherAccountClick?: () => void;
}

const NoAccessPage = ({ userEmail, onSignInWithAnotherAccountClick, children }: PropsWithChildren<Props>) => {
  return (
    <InfoPage
      Icon={<NoAccessIcon />}
      title="You don't have access"
      subtitle={
        <Typography color="textSecondary" sx={{ maxWidth: "40rem" }}>
          It seems you do not have access to this page. If you believe this to be an error, please contact your fund
          manager for further assistance.
          {userEmail ? (
            <>
              {" "}
              You&apos;re signed in as <u>{userEmail}</u>.
            </>
          ) : null}
        </Typography>
      }
    >
      {children}
      {onSignInWithAnotherAccountClick && (
        <Button variant="contained" onClick={onSignInWithAnotherAccountClick}>
          Sign in with another account
        </Button>
      )}
    </InfoPage>
  );
};

export default NoAccessPage;
